<template>
    <van-popup
        v-model="popupCoupon"
        position="right"
        :duration='0'
        :overlay='false'
        :close-on-click-overlay='true'
    >
        <div class="popup">
            <CouponList :getCouponData='couponInfo' @getCouponBack='getCouponBack' />
        </div>
    </van-popup>
</template>

<script>
import CouponList from '../selectEffect'
export default {
    components: {
        CouponList
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        couponInfo: {
            type: null,
            default: null
        }
    },
    computed: {
        // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
        popupCoupon: {
            get () {
                return this.visible
            },
            set () {
                this.$emit('update:visible')
            }
        }
    },
    methods: {
        getCouponBack (item) {
            this.$emit('update:visible')
            if (item) {
                this.$emit('getCouponList', item)
            }
            this.$emit('getFreight')
        }
    }
}
</script>

<style lang="scss" scoped>
.popup {
    background: #ffffff;
    height: 100%;
    position: relative;
}
</style>